export const CategoryColumns = [
  {
    id: "actions",
    title: "Actions",
  },
  {
    id: "name",
    title: "Category Name",
  },
];
